function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.33 1H1v13.43h13.33V1z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#review_new_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.658 5.984L10.37 5.5c-.101-.013-.155-.02-.202-.04a.382.382 0 01-.1-.08.539.539 0 01-.102-.176L8.494 2.225c-.155-.309-.236-.47-.337-.517a.313.313 0 00-.289 0c-.107.047-.181.208-.336.517L6.06 5.205c-.047.093-.067.14-.1.174a.41.41 0 01-.108.08.729.729 0 01-.195.041l-3.288.484c-.35.047-.525.074-.605.162a.337.337 0 00-.088.269c.014.12.141.242.39.484l.572.558 1.809 1.761a.591.591 0 01.134.148c.02.04.034.081.04.128a.63.63 0 01-.02.202l-.403 2.347-.155.92c-.06.35-.094.519-.034.626a.34.34 0 00.236.168c.114.02 1.433-.814 1.742-.975M12.657 8.396H8.534M12.657 10.414H8.534M12.657 12.431H8.534"
}));

var SvgReviewNew = function SvgReviewNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "review_new_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _ref), _ref2);
};

export default SvgReviewNew;